// import React, { lazy, Suspense } from 'react';
import {
    BrowserRouter as Router,
  
    Route,
    Outlet,
    Routes
  } from "react-router-dom";
import Layout from "./Layout";
import Item from "../components/Item";
import SideBar from "../components/SideBar/SideBar";
import DshboardHome from "../components/dashboard/DshboardHome/DshboardHome";
import Login from "../components/auth/Login";
import ProtectedRoute from "../context/ProtectedRoute";
import  Cookies  from 'js-cookie';
// import UserList from "../components/dashboard/Users/UserList";
// import UserForm from "../components/dashboard/Users/UserForm";
import CategoryList from "../components/dashboard/Category/CategoryList";
import EditCategoryPage from "../components/dashboard/Category/EditCategoryPage";
import CategoryForm from "../components/dashboard/Category/CategoryForm";
import SubcategoryList from './../components/dashboard/Subcategory/SubcategoryList';
import SubcategoryForm from "../components/dashboard/Subcategory/SubcategoryForm";
import ItemList from "../components/dashboard/Item/ItemList";
import ItemForm from "../components/dashboard/Item/ItemForm";
import Depositmain from "../components/dashboard/Deposit/Depositmain";
import DepositDetail from "../components/dashboard/Deposit/DepositDetail";
import UserRegistrationForm from "../components/users/UserRegistrationForm";
import UsersList from "../components/users/UsersList";
import UserDetails from "../components/users/UserDetails";
import BidForm from "../socketstest/BidForm";
import CategoryDetails from "../components/dashboard/Category/CategoryDetails";
import SubcategoryDetails from "../components/dashboard/Subcategory/SubcategoryDetails ";
import Newitemform from "../components/dashboard/Item/Newitemform";
import ItemDetails from "../components/dashboard/Item/ItemDetails";
import BookingDetails from "../components/filesbooking/BookingDetails";
import BookingList from "../components/filesbooking/BookingList";
import EndedAuctions from "../components/EndedAuctions/EndedAuctions";
import AuctionDetails from "../components/EndedAuctions/AuctionDetails";
import ViewWinners from "../components/EndedAuctions/ViewWinners";
import ViewLosers from "../components/EndedAuctions/ViewLosers";
import SettingsManager from "../components/dashboard/SettingsManager/SettingsManager";
import WalletChargerAdmin from './../components/WalletChargerAdmin/WalletChargerAdmin';
import PaymentMethod from "../components/dashboard/PaymentMethodinfo/PaymentMethod";
import AuctionComponent from "../components/auctiondetails/AuctionComponent";
import PermissionForm from "../components/dashboard/permmissionsandrole/PermissionForm";
import PermissionsList from "../components/dashboard/permmissionsandrole/PermissionsList";
import AdminList from "../components/dashboard/admins/AdminList";
import AdminPermissions from './../components/dashboard/admins/AdminPermissions';
import UnauthorizedPage from './../context/UnauthorizedPage';
import NotificationManager from "../components/dashboard/NotificationsAdmins/NotificationManager";
import TransactionsManager from "../components/dashboard/transactionwallet/TransactionsManager ";
import SplashScreen from "../components/SplashScreen/SplashScreen";
import SplashList from "../components/SplashScreen/SplashList ";


import {jwtDecode} from 'jwt-decode';
import DownloadAppComponent from "./DownloadAppComponent";
import RefundRequests from "../components/RefundRequests/RefundRequests";
import RefundDetails from "../components/RefundRequests/RefundDetails";
import PaymentDetails from "../components/dashboard/payment/PaymentDetails";
import Billing from "../components/EndedAuctions/Billing";
import UsersTable from "../components/EndedAuctions/UsersTable ";
import Notifications from "../components/Notifications";

const Routess = () => {
  const userCookieadmin = Cookies?.get('user');
  const useradmin = userCookieadmin ? JSON.parse(userCookieadmin) : undefined;
  // const jwtCookieadmin = Cookies?.get('useradmin');

    return ( 
      
                     <Routes >
   <Route path="/auth/login" element={<Login auth={useradmin} />} />
   <Route path="/testbiding" element={<BidForm/>} />
   <Route path='/'  element={<DownloadAppComponent />}/>



   <Route path='/' element={<Layout />}>


   <Route path='/test' element={<Item />}/>

   <Route path='/auction/:id' element={<AuctionComponent />}/>
   <Route path='/unauthorized' element={<UnauthorizedPage />}/>


   {/* <Route path='/dashboard' element={<ProtectedRoute  method="POST" endpoint="/api/v1/item"><CategoryList /></ProtectedRoute>}> */}
   <Route path='/dashboard' element={<ProtectedRoute ><SideBar users={useradmin}  /></ProtectedRoute>}>

   {/* <Route path="/dashboard/admin/users" element={<UserList />} /> */}
   {/* <Route path="/dashboard/admin/categories"  element={<ProtectedRoute  method="GET" endpoint="/api/v1/categories"><CategoryList /></ProtectedRoute>}/> */}
   <Route path="/dashboard/admin/categories"  element={<ProtectedRoute ><CategoryList /></ProtectedRoute>}/>
   <Route path="/dashboard/admin/notifications" element={<NotificationManager />} />
   <Route path="/dashboard/admin/wallettransaction" element={<TransactionsManager />} />

   <Route path='/dashboard/admin/notificationsadmin' element={<Notifications/>}/>

   {/* <Route path="/dashboard/admin/permissions" element={<PermissionForm />} /> */}
   <Route path="/dashboard/admin/permissions" element={<PermissionsList />} />
   {/* <Route path="/dashboard/admin/admins" element={<PermissionsList />} /> */}

   <Route path="/dashboard/admin/admin-list" element={<AdminList />} />
            <Route path="/dashboard/admin/admin-permissions" element={<AdminPermissions />}  />
            <Route path="/dashboard/admin/permissions-list"  element={<PermissionsList />}  />
            <Route path="/dashboard/admin/splash"  element={<SplashScreen />}  />
            <Route path="/dashboard/admin/splashlist"  element={<SplashList />}  />



   <Route path="/dashboard/admin/categories/New"  element={<CategoryForm />} />
   <Route path="/dashboard/admin/categories/:id/edit" element={<EditCategoryPage />} />
   <Route path="/dashboard/admin/categories/:id" element={<CategoryDetails />} />
   <Route path="/dashboard/admin/refund" element={<RefundRequests />} />
   <Route path="/dashboard/admin/refund-details/:id" element={<RefundDetails />} />
   <Route path="/dashboard/admin/Subcategory" element={<SubcategoryList />} />
   <Route path="/dashboard/admin/subcategories/:id/edit" element={<SubcategoryForm />} />
   <Route path="/dashboard/admin/subcategories/new" element={<SubcategoryForm />} />
   <Route path="/dashboard/admin/subcategories/:id" element={<SubcategoryDetails />} />

   <Route path="/dashboard/admin/items" element={<ItemList />} />
   <Route path="/dashboard/admin/items/new" element={<ItemForm />} />
   <Route path="/dashboard/admin/items/:id/edit" element={<ItemForm />} />
   <Route path="/dashboard/admin/items/new:id" element={<Newitemform/>} />
   <Route path="/dashboard/admin/item-details/:itemId" element={<ItemDetails/>} />

   <Route path="/dashboard/admin/deposit" element={<Depositmain />} />
   <Route path="/dashboard/admin/deposit/:id" element={<DepositDetail />} />
   <Route path="/dashboard/admin/users/new" element={<UserRegistrationForm />} />
   <Route path="/dashboard/admin/users" element={<UsersList />} />
   <Route path="/dashboard/admin/users/:userId" element={<UserDetails />} />
   <Route path="/dashboard/admin/filesbooking" element={<BookingList />} />
   <Route path="/dashboard/admin/ended-auctions" element={<EndedAuctions />} />
   <Route path="/dashboard/admin/subcategory/:subcategoryId/users" element={<UsersTable />} />
   <Route path="/dashboard/admin/auctions/:id" element={<AuctionDetails />} />
   <Route path="/dashboard/admin/auctions/billings/:id" element={<Billing />} />

   <Route path="/dashboard/admin/filesbooking/:id" element={<BookingDetails />} />
   <Route path="/dashboard/admin/setting" element={<SettingsManager />} />
   <Route path="/dashboard/admin/walletcharger" element={<WalletChargerAdmin />} />
   <Route path="/dashboard/admin/paymentinfo" element={<PaymentMethod />} />
   <Route path="/dashboard/admin/payment" element={<PaymentDetails />} />





   <Route path="/dashboard/admin/auctions/:itemId/winner" element={<ViewWinners />} />
   <Route path="/dashboard/admin/auctions/:itemId/loser" element={<ViewLosers />} />












      {/* <Route path="/dashboard/admin/create-user" element={<UserForm />} /> */}
      {/* <Route path="/dashboard/admin/edit-user/:id" element={<UserForm />} /> */}
   {/* <Route path='/dashboard/home' element={<ProtectedRoute><DshboardHome /></ProtectedRoute>}/> */}


   </Route>





   </Route>



    </Routes>
        
    );
}

export default Routess;
